(function (){
    'use strict';

    angular
        .module('services')
        .service('ReportsPartnersService', ReportsPartnersService);

    ReportsPartnersService.$inject = ['$http', 'API_BASE'];

    function ReportsPartnersService ($http, API_BASE) {
        var service = this;

        service.getTswReport = getTswReport;
        service.getCareerAdvisorsReport = getCareerAdvisorsReport;


        function getTswReport() {
            return $http.get(API_BASE + '/partners/tsw_report');
        }

        function getCareerAdvisorsReport(filters) {
            return $http.get(API_BASE + '/partners/reports/career_advisors', {params: filters});
        }
    }
})();